import WorkspaceLoadingScreen from '../../components/loading/workspace/WorkspaceLoadingScreen';
import NeatScheduleMark from '../../shared/components/brand/NeatScheduleMark';
import { adminLocationHref } from '../../admin-panel/config/adminHost';
import { ADMIN_PATHS } from '../../admin-panel/constants/adminPaths';
import './ImpersonationAuthScreen.css';

const ImpersonationAuthScreen = ({
  status = 'loading',
  message = 'Signing into this account...',
  detail,
  error,
  onRetry,
}) => {
  if (status === 'error') {
    return (
      <div className="impersonationAuth" role="alert">
        <div className="impersonationAuth__card">
          <NeatScheduleMark className="impersonationAuth__logo" />
          <h1 className="impersonationAuth__title">Couldn’t open this account</h1>
          <p className="impersonationAuth__body">
            {error || 'The impersonation session failed to start.'}
          </p>
          <div className="impersonationAuth__actions">
            {onRetry ? (
              <button type="button" className="impersonationAuth__btn impersonationAuth__btn--primary" onClick={onRetry}>
                Try again
              </button>
            ) : null}
            <button
              type="button"
              className="impersonationAuth__btn"
              onClick={() => window.location.replace(adminLocationHref(ADMIN_PATHS.IMPERSONATION))}
            >
              Back to admin
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <WorkspaceLoadingScreen
      message={message}
      detail={detail}
    />
  );
};

export default ImpersonationAuthScreen;
